import { store } from '../store/store';
import { addToast, ToastType } from '../store/slices/toastsSlice';

/**
 * Helper function to show a toast notification from anywhere in the app
 * @param message - The message to display in the toast
 * @param type - The type of toast ('success' | 'error' | 'info' | 'warning')
 * @param duration - Optional custom duration in milliseconds
 * @example
 * showToast('Order saved successfully!', 'success');
 * showToast('An error occurred', 'error', 5000);
 */
export const showToast = (message: string, type: ToastType = 'info', duration?: number): void => {
  store.dispatch(addToast(message, type, duration));
};
